import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../apiConfig";
import { useNavigate } from "react-router-dom";
import SidebarMenu from '../components/SidebarMenu';



const ConsultaEventosMasivos = () => {
  const [eventosMasivos, setEventosMasivos] = useState([]);
  const [eventoSeleccionado, setEventoSeleccionado] = useState("");
  const [detallesEvento, setDetallesEvento] = useState(null);
  const [participantes, setParticipantes] = useState([]);
  const [resumenLideres, setResumenLideres] = useState([]);
  const navigate = useNavigate();
  const [showDetails, setShowDetails] = useState(false);


  useEffect(() => {
    const fetchEventosMasivos = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/Eventos/EventosMasivos`);
        setEventosMasivos(response.data);
      } catch (error) {
        console.error("Error al obtener eventos masivos:", error);
      }
    };

    fetchEventosMasivos();
  }, []);


  const handleSeleccionEvento = async (eventoId, forzarRecarga = false) => {
    if (eventoId !== eventoSeleccionado || forzarRecarga) {
      setEventoSeleccionado(eventoId);
    }
    //setEventoSeleccionado(eventoId);
    if (!eventoId) {
      setDetallesEvento(null);
      setParticipantes([]);
      setResumenLideres([]);
      return;
    }

    try {
      const responseEvento = await axios.get(`${API_BASE_URL}/Eventos/DetalleEvento/${eventoId}`);
      setDetallesEvento(responseEvento.data);

      const responseParticipantes = await axios.get(`${API_BASE_URL}/Eventos/ParticipantesEvento/${eventoId}`);

      console.log(" Datos recibidos del backend:", responseParticipantes.data);
      console.log(" Líderes en respuesta:", responseParticipantes.data.resumenLideres);

      //  VERIFICAR QUE LA RESPUESTA TRAE A TODOS LOS LÍDERES
      const lideres = responseParticipantes.data.resumenLideres || [];
      console.log("🟢 Líderes obtenidos:", lideres.map(l => l.lider));

      //  FORZAR REACT A ACTUALIZAR EL ESTADO
      setParticipantes([...responseParticipantes.data.participantes]);
      setResumenLideres([...lideres]); // Asegurar que React lo almacene correctamente

    } catch (error) {
      console.error("❌ Error al obtener los datos del evento:", error);
    }
  };

  // const handleReload = () => {
  //   // Recarga la página
  //   window.location.reload();
  // };
  const handleReload = () => {
    if (eventoSeleccionado) {
      handleSeleccionEvento(eventoSeleccionado, true); // Aquí sí le pasamos el segundo argumento
    }
  };



  <button
  onClick={() => setShowDetails(prev => !prev)}
  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded my-4"
>
  {showDetails ? 'Ocultar detalles del evento' : 'Detalles del evento'}
</button>



  return (
    <div className=" w-full max-w-4xl mx-auto lg:max-w-4xl xl:max-w-6xl p-6">
       <SidebarMenu />


       <div className="bg-[#081b29] p-4 flex items-center justify-between">
      {/* Logo y Título juntos en el lado izquierdo */}
      <div className="flex items-center space-x-4">
        <img src="/img/monytorlogoa.png" alt="Logo" className="w=32 h-32" />
        <h2 className="text-white text-3xl font-bold">Consulta de Eventos Masivos</h2>
      </div>

      {/* Botón en el lado derecho */}
      <button
      className="btn text-white font-bold py-1 px-2 rounded"
      style={{ width: '180px' }}  // Ancho fijo
      onClick={() => navigate("/admin/menu")}
    >
        Menú
      </button>
    </div>

    <div className="w-full max-width">
      <label className="block text-lg mb-2">Selecciona un evento masivo:</label>
      <select
        className="w-full p-2 border border-gray-300 rounded text-black"
        value={eventoSeleccionado}
        onChange={(e) => handleSeleccionEvento(e.target.value)}
      >
        <option value="">-- Seleccionar Evento --</option>
        {eventosMasivos.map((evento) => (
          <option key={evento.id} value={evento.id}>
            {evento.nombreEvento}
          </option>
        ))}
      </select>
      </div>
      <h4 className="mt-3 text-white px-4 py-2 rounded-lg inline-block">
        Total de Participantes que asistieron: {participantes.length}
      </h4>

      <br></br>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <button
          style={{ width: '180px' }}
          onClick={() => setShowDetails(prev => !prev)}
          className="btn text-white font-bold py-1 px-2 rounded my-4"
        >
          {showDetails ? 'Ocultar detalles' : 'Detalles del evento'}
        </button>

        <button
          style={{ width: '180px' }}
          onClick={handleReload}
          className="btn text-white font-bold py-1 px-2 rounded my-4"
        >
          Recargar Datos
        </button>
      </div>



      {showDetails && detallesEvento && (
        <div className="bg-gray-800 text-white p-4 rounded shadow-md">
          {/* Detalles del evento aquí */}
        </div>
      )}

      {showDetails && detallesEvento && (
  <div className="bg-gray-800 text-white p-4 rounded shadow-md" max-width>
    <h3 className="text-xl font-semibold">{detallesEvento.nombreEvento}</h3>
    <p><strong>Descripción:</strong> {detallesEvento.descripcionEvento}</p>
    <p><strong>Fecha de Inicio:</strong> {new Date(detallesEvento.fechaInicio).toLocaleString()}</p>
    <p><strong>Fecha de Fin:</strong> {new Date(detallesEvento.fechaFin).toLocaleString()}</p>
    <p><strong>Meta:</strong> {detallesEvento.meta}</p>
    <p><strong>Estatus:</strong> {detallesEvento.estatusEvento}</p>
  </div>
)}


      {/* {resumenLideres.length >= 0 && (
        <div className="mt-6 bg-gray-700 text-white p-4 rounded shadow-md">
          <h3 className="text-lg font-semibold">Resumen por Líder</h3>
          <table className="table-auto w-full mt-4 border border-gray-600">
            <thead>
              <tr className="bg-gray-600">
                <th className="px-4 py-2 border">Líder</th>
                <th className="px-4 py-2 border">Meta</th>
                <th className="px-4 py-2 border">Participantes Asistentes</th>
                <th className="px-4 py-2 border">Cumplimiento (%)</th>
              </tr>
            </thead>
            <tbody>
              {resumenLideres.map((lider, index) => {
                const porcentajeCumplimiento =
                  detallesEvento.meta > 0
                    ? ((lider.totalParticipantes / detallesEvento.meta) * 100).toFixed(2)
                    : "0.00";
                return (
                  <tr key={index} className="text-center bg-gray-200 text-black">
                    <td className="px-4 py-2 border">{lider.lider}</td>
                    <td className="px-4 py-2 border">{detallesEvento.meta}</td>
                    <td className="px-4 py-2 border">{lider.totalParticipantes}</td>
                    <td className="px-4 py-2 border">{porcentajeCumplimiento}%</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )} */}
      {resumenLideres && resumenLideres.length >= 0 && (
        <div className="mt-6 bg-gray-700 text-white p-4 rounded shadow-md w-full max-width " >
          <h3 className="text-lg font-semibold">Resumen por Líder {resumenLideres.length}</h3>
          <table className="min-w-full table-auto mt-4 border border-gray-600">
            <thead>
              <tr className="bg-gray-600">
                <th className="px-4 py-2 border">Líder</th>
                <th className="px-4 py-2 border">Meta</th>
                <th className="px-4 py-2 border">Participantes Asistentes</th>
                <th className="px-4 py-2 border">Cumplimiento (%)</th>
              </tr>
            </thead>
            <tbody>
              {resumenLideres.map((lider, index) => {
                const participantes = lider.totalParticipantes ?? 0; //  Asegurar que nunca sea undefined
                const porcentajeCumplimiento =
                  detallesEvento && detallesEvento.meta > 0
                    ? ((participantes / detallesEvento.meta) * 100).toFixed(2)
                    : "0.00";

                return (
                  <tr key={index} className="text-center bg-gray-200 text-black">
                    <td className="px-4 py-2 border">{lider.lider}</td>
                    <td className="px-4 py-2 border">{detallesEvento ? detallesEvento.meta : "N/A"}</td>
                    <td className="px-4 py-2 border">{participantes}</td>
                    <td className="px-4 py-2 border">{porcentajeCumplimiento}%</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {participantes.length > 0 ? (
        <div className="mt-6" w-full>
          <h3 className="text-lg font-semibold">Participantes Asistentes</h3>
          <table className="table-auto w-full mt-4 border border-gray-700">
            <thead>
              <tr className="bg-gray-700 text-white">
                <th className="px-4 py-2 border">Líder que lo Registró</th>
                <th className="px-4 py-2 border">Nombre Completo</th>
                <th className="px-4 py-2 border">Fecha de Alta</th>
              </tr>
            </thead>
            <tbody>
              {participantes.map((p, index) => (
                <tr key={index} className="text-center bg-gray-200 text-black">
                  <td className="px-4 py-2 border">{p.liderRegistrador || "Desconocido"}</td>
                  <td className="px-4 py-2 border">{p.nombreCompleto}</td>
                  <td className="px-4 py-2 border">{new Date(p.fechaAlta).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
};

export default ConsultaEventosMasivos;
